import React from "react"
import { useTranslation } from "react-i18next"
import { connectInfiniteHits } from "react-instantsearch-dom"

import Button from "@atoms/Button/Button"

import styles from "./CustomInfiniteHits.module.scss"
import Hit from "./Hit"

const InfiniteHits = ({ hits, hasMore, refineNext }) => {
  const { t } = useTranslation()

  // aria-live? Please read https://stackoverflow.com/questions/57884644/ios-safari-voiceover-how-to-read-dynamic-content

  return (
    <div role="region" aria-live="polite">
      {hits.map((hit) => (
        <Hit hit={hit} key={hit.objectID}>
          {hit.name}
        </Hit>
      ))}

      {hasMore && hits.length && (
        <div className={styles.loadMoreButtonContainer}>
          <Button variant="black" size="small" onClick={refineNext}>
            {t("Show more")}
          </Button>
        </div>
      )}
    </div>
  )
}

const CustomInfiniteHits = connectInfiniteHits(InfiniteHits)

export default CustomInfiniteHits
